import { gql } from '@lichtblick/apollo';

export const GET_TEAMS_FILTER_OPTIONS = gql`
  query GetTeams($input: GetTeamsInput) {
    getTeams_V1(input: $input) {
      totalItems
      error
      data {
        id
        isDeleted
        name
        branchOffice {
          name
        }
      }
    }
  }
`;

export const GET_TEAMS_LIST = gql`
  query GetTeams_V1($input: GetTeamsInput) {
    getTeams_V1(input: $input) {
      totalItems
      data {
        id
        name
        isDeleted
        branchOffice {
          id
          name
          serviceProvider {
            id
            name
          }
        }
        skills {
          id
          workflowDefinition {
            id
            name
          }
        }
        members {
          id
          firstName
          lastName
          eMail
        }
      }
      error
    }
  }
`;

export const CREATE_TEAM = gql`
  mutation createTeam_V1($input: CreateTeamInput!) {
    createTeam_V1(input: $input) {
      data {
        id
        name
        branchOffice {
          id
          name
        }
        skills {
          id
          workflowDefinition {
            id
            name
          }
        }
        members {
          id
          firstName
          lastName
          eMail
        }
      }
      error
    }
  }
`;

export const UPDATE_TEAM = gql`
  mutation updateTeam_V1($input: UpdateTeamInput!) {
    updateTeam_V1(input: $input) {
      data {
        id
        name
        branchOffice {
          id
          name
        }
        skills {
          id
          workflowDefinition {
            id
            name
          }
        }
        members {
          id
          firstName
          lastName
          eMail
        }
      }
      error
    }
  }
`;
